import {
  LINK_DASHBOARD, LINK_PBL, LINK_SETTINGS, LINK_TERMINALS,
  LINK_TRANSACTIONS, MERCHANT_SETTINGS_SUBMENU, MERCHANT_TERMINAL_SUBMENU
} from "../../../../../constants/links";
import {
  PERMISSION_DASHBOARD,
  PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS
} from "../../../../../constants/permissions";

const getIconPath = (name) => require(`../../../assets/svg/${name}`);

export const NAVIGATION_MERCHANT = [
  {
    id: 'dashboard',
    name: 'Dashboard',
    link: LINK_DASHBOARD,
    icon: getIconPath('Dashboard'),
    permissions: [PERMISSION_DASHBOARD],
  },
  {
    id: 'trx',
    name: 'Transactions',
    link: LINK_TRANSACTIONS,
    icon: getIconPath('Transactions'),
  },
  {
    id: 'pbl',
    name: 'Pay by Link',
    link: LINK_PBL,
    icon: getIconPath('Invoices'),
  },
  {
    id: 'terminals',
    name: 'Terminal',
    link: LINK_TERMINALS,
    icon: getIconPath('Terminal'),
    subLinks: MERCHANT_TERMINAL_SUBMENU,
    permissions: [PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS]
  },
  {
    id: 'settings',
    name: 'Settings',
    link: LINK_SETTINGS,
    icon: getIconPath('Settings'),
    subLinks: MERCHANT_SETTINGS_SUBMENU
  },
  // {
  //   name: 'Management',
  //   link: LINK_MANAGEMENT,
  //   icon: require('./icons/Management'),
  // },
  // {
  //   name: 'Settings',
  //   link: LINK_SETTINGS,
  //   icon: require('./icons/Settings'),
  // },
  // {
  //   name: 'Developer options',
  //   link: LINK_DEVELOPER_OPTIONS,
  //   icon: require('./icons/DeveloperOptions'),
  //   disabled: !isUserAccessed(PERMISSION_ACCESS_PERMISSIONS),
  // },
  // {
  //   name: 'Help and support',
  //   link: LINK_HELP,
  //   icon: require('./icons/Help'),
  // },
];
